export default __webpack_public_path__ + "static/media/36I-102743_-15823_0.4c795f5d.jpg";